<template>
  <v-dialog v-model="show" width="60%" persistent>
    <v-card id="modalContainerCard">
      <v-icon class="modal-close" @click.stop="$emit('close-modal')">
        close
      </v-icon>
      <div class="modal-send-message__title">
        <slot />
      </div>
      <div class="modal-content">
        <v-btn
          class="modal-button"
          :color="colors.scheduled"
          @click.stop="$emit('click-button')"
        >
          {{ buttonText }}
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapState } from 'vuex'
import colors from '../../scss/_colors.scss'

export default {
  props: {
    show: {
      type: Boolean,
      default: false
    },
    buttonText: {
      type: String,
      default: 'OK'
    }
  },

  data() {
    return {
      colors
    }
  },

  computed: {
    ...mapState('style', ['modal'])
  }
}
</script>

<style lang="sass" scoped>
#modalContainerCard
  padding: 4rem 4rem 2rem

.modal-close
  @extend %modal__button-close, %disable-selection

.modal-send-message__title
  font-size: $hwayzFont1rem8
  text-transform: capitalize

.modal-content
  padding: 2rem
  display: inline-block
  .modal-button
    width: 30%
    border-radius: 20px
    color: $hwayzWhite
    font-weight: 300 !important
  .cancel
    border: 1px solid $hwayzRed !important
    color: $hwayzRed
.v-menu__content
  box-shadow: none
.modal-content
  border: none !important

@media only screen and (min-width: 600px)
  .modal-content
    padding: 3rem
</style>
